import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        await refresh();
        // Clean URL hash
        window.history.replaceState({}, document.title, "/dashboard");
        toast.success("Signed in with Google");
        navigate("/dashboard", { replace: true });
      } catch (err) {
        toast.error(apiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-sm text-muted-foreground">Signing you in…</div>
  );
}
